import React from 'react';
import ReactDOM from 'react-dom/client';

// Roboto font
import '@fontsource/roboto';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// SweetAlert2 styles (use SCSS since v11+ removed CSS dist)
import 'sweetalert2/src/sweetalert2.scss';

// Global styles
import './index.css';
import './styles/utility-classes.css';

import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
